export default __webpack_public_path__ + "components/weather-icon/static/daylightsnow@2-6c14c9c10696ddf242a302a499d19145.png";